import React, { FC, Fragment, useContext, useState } from 'react';
import { HeadingItem } from 'components/heading-item/heading-item';
import { CheckBox, TextBox } from 'devextreme-react'
import './add-email-address.scss'
import { validateEmail } from 'helpers/emailHelper';
import { ActionButton } from 'components/action-button/action-button';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { useEmailService } from 'services/useEmailService';
import { useNavigation } from 'services';
import { TripContext } from 'contexts';
import { Stop } from 'services/types';

type Props = {
    stopId: number
}

export const AddEmailAddress: FC<Props> = ({stopId}) => {
    const tripContext = useContext(TripContext)
    const { addEmailToContext } = useEmailService()

    const [newEmailAddress, setNewEmailAddress] = useState<string>("")
    const [isNewEmailAddressValid, setIsNewEmailAddressValid] = useState<boolean>(true)

    const [verifyNewEmailAddress, setVerifyNewEmailAddress] = useState<string>("")
    const [isVerifyNewEmailAddressValid, setIsVerifyNewEmailAddressValid] = useState<boolean>(true)

    const [isPreDelivery, setIsPreDelivery] = useState<boolean>(false)
    const [isPostDelivery, setIsPostDelivery] = useState<boolean>(false)

    const [emailsAreNotTheSame, setEmailsAreNotTheSame] = useState<boolean>(false)

    const stop: Stop = tripContext.stops.find(stop => stop.id == stopId) ?? {} as Stop
    const companyId = stop.companyId;

    const checkEmails = (newEmailAddress: string, verifyNewEmailAddress: string) => {
        if (newEmailAddress.length > 0 && verifyNewEmailAddress.length > 0) {
            setEmailsAreNotTheSame(newEmailAddress != verifyNewEmailAddress)
        }

        if (newEmailAddress.length > 0) {
            setIsNewEmailAddressValid(validateEmail(newEmailAddress))
        }

        if (verifyNewEmailAddress) {
            setIsVerifyNewEmailAddressValid(validateEmail(verifyNewEmailAddress))
        }
    }

    const emailCanBeAdded = (): boolean => {
        if (newEmailAddress.length == 0 && newEmailAddress.length == 0)
            return false;

        if (newEmailAddress != verifyNewEmailAddress)
            return false;

        if (!isPreDelivery && !isPostDelivery)
            return false;

        return true;
    }

    return (
        <Fragment>
            <div className={'card-material'}>
                <HeadingItem text='Add New E-mail Address' />
                
                <div className={'add-email-address-wrapper'}>
                    <div className={'add-email-address-text'}>
                        Add new e-mail:
                    </div>

                    <div className={`add-email-address-textbox ${emailsAreNotTheSame ? 'error' : ''}`}>
                        <TextBox
                            disabled={false}
                            placeholder="New e-mail"
                            value={newEmailAddress}
                            onValueChanged={e => {
                                if (e.value === null)
                                    return;

                                setNewEmailAddress(e.value)
                                checkEmails(e.value, verifyNewEmailAddress)
                            }}
                        />
                    </div>
                    {emailsAreNotTheSame &&
                        <div className={'validation-error'}>The emails do not match</div>
                    }

                    {!isNewEmailAddressValid &&
                        <div className={'validation-error'}>This is not a valid email</div>
                    }

                    <div className={'add-email-address-text'}>
                        Verify new e-mail:
                    </div>

                    <div className={`add-email-address-textbox ${emailsAreNotTheSame ? 'error' : ''}`}>
                        <TextBox
                            disabled={false}
                            placeholder="New e-mail"
                            value={verifyNewEmailAddress}
                            onValueChanged={e => {
                                if (e.value === null)
                                    return;

                                setVerifyNewEmailAddress(e.value)
                                checkEmails(newEmailAddress, e.value)
                            }}                        
                        />
                    </div>

                    {!isVerifyNewEmailAddressValid &&
                        <div className={'validation-error'}>This is not a valid email</div>
                    }
                </div>

                <div className={'add-email-address-wrapper'}>
                    <div className={'add-email-address-type-header bold'}>
                        Select receipt type
                    </div>

                    <div className={'add-email-address-checkbox'}>
                        <CheckBox
                            name={'Accept'}
                            value={isPreDelivery}
                            disabled={false}
                            onValueChanged={() => setIsPreDelivery(!isPreDelivery)}
                        />
                        <div onClick={() => setIsPreDelivery(!isPreDelivery)} className={'add-email-address-checkbox-text'}>Pre-delivery</div>
                    </div>

                    <div className={'add-email-address-checkbox'}>
                    
                        <CheckBox
                            name={'Accept'}
                            value={isPostDelivery}
                            disabled={false}
                            onValueChanged={() => setIsPostDelivery(!isPostDelivery)}
                        />
                        <div onClick={() => setIsPostDelivery(!isPostDelivery)} className={'add-email-address-checkbox-text'}>Post-delivery</div>
                    </div>
                </div>

                <hr />

                <div className={'add-email-address-ok-button'}>
                    <ActionButton
                        enabled={emailCanBeAdded()}
                        icon={faArrowRight}
                        buttonColor={'#76AB21'}
                        onClick={() => {
                            addEmailToContext(newEmailAddress, isPreDelivery, isPostDelivery, companyId)
                            setNewEmailAddress('')
                            setIsPreDelivery(false)
                            setIsPostDelivery(false)
                            setVerifyNewEmailAddress('')
                        }}
                        buttonText={'Ok'}
                    />
                </div>
            </div>
        </Fragment>
    )
}